import React from 'react';
import PropTypes from 'prop-types';
import AmplifyModal from '@amplify/amplify-modal';
import './DemoCompleteModal.scss';

const DemoCompleteModal = ({
    handleClose,
    onSelfExploreMode,
    handleGoToBenchmark,
    isCompleteModelOpen,
}) => {
    return (
        <div id="demo-complete-modal">
            <AmplifyModal
                fitContent
                aria-labelledby="demo-complete-modal"
                onClose={handleClose}
                open={isCompleteModelOpen}
                title="Great Job!"
                primaryButtonText="Go to Benchmark"
                secondaryButtonText="Continue to Self Explore"
                onPrimaryAction={handleGoToBenchmark}
                onSecondaryAction={onSelfExploreMode}
            >
                <div className="flex-row demo-complete-modal layout-context-compact">
                    <div className="demo-complete-modal-content">
                        <div>Success! You have completed the guided tour of mCLASS Reporting.</div>
                        <br />
                        <div>
                            You can now exit Demo Mode to review your students&apos; results, or
                            continue with the demo in Self Explore mode.
                        </div>
                    </div>
                </div>
            </AmplifyModal>
        </div>
    );
};
DemoCompleteModal.defaultProps = {
    isCompleteModelOpen: false,
    handleClose: () => {},
    onSelfExploreMode: () => {},
    handleGoToBenchmark: () => {},
};
DemoCompleteModal.propTypes = {
    isCompleteModelOpen: PropTypes.bool,
    handleClose: PropTypes.func,
    onSelfExploreMode: PropTypes.func,
    handleGoToBenchmark: PropTypes.func,
};

export default DemoCompleteModal;
